export default "__VITE_ASSET__AtSFbCGV__"